import ListPageApi from "../api/listPage.api";
import * as actionTypes from "Consts/index";

export const getAllCategories = (pageId, lang) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.LISTPAGE__LOADINGCATEGORIES,
      payload: true,
    });

    ListPageApi.getAllCategories(pageId, lang)
      .then((res) => {
        dispatch({
          type: actionTypes.LISTPAGE__GETALLCATEGORIES,
          payload: res,
        });
        dispatch({
          type: actionTypes.LISTPAGE__LOADINGCATEGORIES,
          payload: false,
        });
      })
      .catch((e) => console.error(e));
  };
};

export const getItems = (pageId, page, lang, categories, cleanresult) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.LISTPAGE__LOADING,
      payload: true,
    });

    ListPageApi.getItems(pageId, page, lang, categories)
      .then((res) => {
        const { loadMore, searchHits, searchHitsText } = res;

        const items = searchHits?.map((c) => {
          return {
            Heading: c.heading,
            Url: c.url,
            Category: c.category,
            Description: c.description,
            ResponsiveImage: {
              Desktop: c?.responsiveImage?.desktop,
              Ipad: c?.responsiveImage?.ipad,
              Mobile: c?.responsiveImage?.mobile,
            },
            DocumentType: c.documentType,
            CategoryColor: c.categoryColor,
          };
        });
        dispatch({
          type: actionTypes.LISTPAGE__SETCATEGORIES,
          payload: categories,
        });
        dispatch({
          type: actionTypes.LISTPAGE__GETITEMS,
          payload: {
            loadMore,
            searchHits: items ?? [],
            searchHitsText,
            cleanresult,
          },
        });
        dispatch({
          type: actionTypes.LISTPAGE__LOADING,
          payload: false,
        });
      })
      .catch((e) => console.error(e));
  };
};
